import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
import { regularButtonCommonClasses, regularButtonVariantClasses } from "@/components/Button/regular-button-class-names";
import { CardBody } from "@/components/Card/_components/CardBody/CardBody.component";
import { CardFooter } from "@/components/Card/_components/CardFooter/CardFooter.component";
import { CardHeading } from "@/components/Card/_components/CardHeading/CardHeading.component";
import { Card } from "@/components/Card/Card.component";
import type { LinkProps } from "@/components/Link/Link.component";
import { Price } from "@/components/Price/Price.component";
import { Translation } from "@/components/Translation/Translation.component";
import type { Translations } from "@/components/Translation/translation.types";
import type { ProductModel } from "@/services/api/shop/models/product.model";
type ProductCardProps = {
  readonly className?: string;
  readonly children: ReactNode;
  readonly size?: "small" | "medium" | "large" | "default";
  readonly model: {
    readonly product?: Pick<ProductModel, "price" | "currency">;
    readonly titleTranslations: Translations;
    readonly periodHeadingTranslations?: Translations;
    readonly periodTranslations?: Translations;
    readonly url: string;
    readonly buttonTranslations: Translations;
    readonly position?: string;
    readonly testId?: string;
    readonly footNoteStarCount?: number;
    readonly variant?: "primary" | "default" | "subtle";
    readonly trackingModel?: LinkProps["trackingModel"];
  };
};
export function ProductCard(t0) {
  const $ = _c(37);
  const {
    className,
    children,
    size,
    model: t1
  } = t0;
  const {
    product,
    titleTranslations,
    periodHeadingTranslations,
    periodTranslations,
    url,
    buttonTranslations,
    variant: t2,
    position,
    testId,
    footNoteStarCount: t3,
    trackingModel
  } = t1;
  const variant = t2 === undefined ? "default" : t2;
  const footNoteStarCount = t3 === undefined ? 0 : t3;
  let t4;
  if ($[0] !== footNoteStarCount) {
    t4 = "*".repeat(footNoteStarCount);
    $[0] = footNoteStarCount;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const stars = t4;
  let t5;
  if ($[2] !== className) {
    t5 = clsx("relative flex max-w-full flex-auto cursor-pointer flex-col transition-all lg:hover:scale-102 lg:hover:shadow-2xl", className);
    $[2] = className;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = variant === "subtle" ? "subtle" : "default";
  const t7 = variant === "subtle" ? "silver" : "secondary";
  let t8;
  if ($[4] !== titleTranslations) {
    t8 = <Translation model={titleTranslations} />;
    $[4] = titleTranslations;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== periodHeadingTranslations) {
    t9 = periodHeadingTranslations !== undefined ? <div className="font-normal text-base"><Translation model={periodHeadingTranslations} /></div> : null;
    $[6] = periodHeadingTranslations;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== t7 || $[9] !== t8 || $[10] !== t9) {
    t10 = <CardHeading className="flex flex-col" variant={t7}>{t8}{t9}</CardHeading>;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== periodTranslations || $[13] !== product || $[14] !== stars) {
    t11 = product !== undefined ? <div><div className="mb-1 font-bold text-xl leading-tight"><Price className="inline-block" currency={product.currency} price={product.price} />{periodTranslations !== undefined ? <>{" "}<small className="font-normal text-xs">/ <Translation model={periodTranslations} />{stars !== "" ? <sup>{stars}</sup> : null}</small></> : null}</div><p className="font-normal text-xs leading-tight"><Translation da="Ekskl. moms" de="Exkl. MwSt" en="Excl. VAT" no="Ekskl. mva" sv="Exkl. moms" /><br /><Translation da="Pris inkl. moms vises ved checkout" de="Preis inkl. MwSt. wird an der Kasse angezeigt" en="Price incl. VAT shown at checkout" no="Pris inkl. MVA vises ved kassen" sv="Pris inkl. moms visas vid kassan" /></p></div> : null;
    $[12] = periodTranslations;
    $[13] = product;
    $[14] = stars;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== children || $[17] !== t11) {
    t12 = <CardBody className="flex flex-col items-center justify-center gap-1.5 py-0">{children}{t11}</CardBody>;
    $[16] = children;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = regularButtonVariantClasses[variant === "primary" ? "primary" : "black"];
  let t14;
  if ($[19] !== t13) {
    t14 = clsx(regularButtonCommonClasses, t13, "w-full");
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== buttonTranslations) {
    t15 = <Translation model={buttonTranslations} />;
    $[21] = buttonTranslations;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14 || $[24] !== t15) {
    t16 = <CardFooter><div className={t14}>{t15}</div></CardFooter>;
    $[23] = t14;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== position || $[27] !== size || $[28] !== t10 || $[29] !== t12 || $[30] !== t16 || $[31] !== t5 || $[32] !== t6 || $[33] !== testId || $[34] !== trackingModel || $[35] !== url) {
    t17 = <Card className={t5} href={url} position={position} size={size} testId={testId} trackingModel={trackingModel} variant={t6}>{t10}{t12}{t16}</Card>;
    $[26] = position;
    $[27] = size;
    $[28] = t10;
    $[29] = t12;
    $[30] = t16;
    $[31] = t5;
    $[32] = t6;
    $[33] = testId;
    $[34] = trackingModel;
    $[35] = url;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}